import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const MAP = {
  start: {
    label: 'Start',
    icon: 'hmm-icon-play',
  },
  done: {
    label: 'Done',
    icon: 'hmm-icon-check',
  },
  switch: {
    label: 'Switch',
    icon: 'hmm-icon-switch',
  },
  continue: {
    label: 'Continue',
    icon: 'hmm-icon-continue',
  },
  active: {
    label: 'Active',
    icon: 'hmm-icon-active',
  },
  empty: {
    label: 'Empty',
    icon: 'hmm-icon-square-empty',
  },
  partial: {
    label: 'Partial',
    icon: 'hmm-icon-square-partial',
  },
  complete: {
    label: 'Complete',
    icon: 'hmm-icon-square-checked',
  },
  engagement: {
    label: 'Engagement',
    icon: 'hmm-icon-engagement',
  },
  emotions: {
    label: 'Emotions',
    icon: 'hmm-icon-emotions',
  },
  thoughts: {
    label: 'Thoughts',
    icon: 'hmm-icon-thoughts',
  },
  tasks: {
    label: 'Tasks',
    icon: 'hmm-icon-tasks',
  },
  frown: {
    label: 'Frown',
    icon: 'hmm-icon-frown',
  },
  meh: {
    label: 'Meh',
    icon: 'hmm-icon-meh',
  },
  smile: {
    label: 'Smile',
    icon: 'hmm-icon-smile',
  },
  'frown-balloon': {
    label: 'Frown',
    icon: 'hmm-icon-baloon-frown',
  },
  'meh-balloon': {
    label: 'Meh',
    icon: 'hmm-icon-baloon-meh',
  },
  'smile-balloon': {
    label: 'Smile',
    icon: 'hmm-icon-baloon-smile',
  },
}

class Icon extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    isButton: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    color: PropTypes.string,
    size: PropTypes.number,
    style: PropTypes.object,
    containerStyle: PropTypes.object,
  }

  static defaultProps = {
    disabled: false,
    onClick: () => {},
    color: 'white',
    size: 22,
    isButton: false,
    style: {},
    containerStyle: {},
  }

  render() {
    const { type, isButton, disabled, onClick, color, size, style, containerStyle } = this.props
    const { label, icon } = MAP[type]
    return (
      <button
        className={styles.button}
        disabled={disabled}
        onClick={onClick}
        style={containerStyle}
      >
        {isButton && (
          <div className={styles.buttonContent}>
            <span
              className={classnames(icon, styles.icon, disabled && styles['disabled-icon'])}
              style={style}
            />
            <div className={styles.label}>{label}</div>
          </div>
        )}
        {!isButton && (
          <div className={styles.buttonContent}>
            <span className={icon} style={{ color, fontSize: size }} />
          </div>
        )}
      </button>
    )
  }
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/icon/index.js